const parseAxiosError = (e) => {
    let res;
    if (e.response) {
        const responseData = e.response.data;
        const responseMessage = responseData.message;
        const responseError = responseData.error;
        res = responseMessage || responseError || responseData;
    }
    else if (e.request) {
        res = e.request;
    }
    else {
        res = e.message;
    }
    return new Error(typeof res === 'string' ? res : e.message);
};
export default parseAxiosError;
//# sourceMappingURL=parseAxiosError.js.map